import CalendarBig from './CalendarBig';
export default CalendarBig;